module.exports = __webpack_public_path__ + "media/images/sala-catas-a9a489036c111b55340863bd164bb789.jpg";